import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';
import { ParametersPageButton } from '../../ParametersPage/styles';
import { ActionButton } from '../../../utils/driveItem';
import { hexToRgba } from '../../../utils/style';

interface DriveItemDownloadButtonProps {
	color: string;
	action: ActionButton;
}

const StyledDownloadGroupButton = styled(ParametersPageButton)`
	background-color: ${(props: DriveItemDownloadButtonProps) => hexToRgba(props.color || StyleColor.Blue600, 10)};
	color: ${(props: DriveItemDownloadButtonProps) => props.color || StyleColor.Blue600};

	& div {
		width: 100%;
		text-align: center;
	}

	&:hover {
		background-color: ${(props: DriveItemDownloadButtonProps) => hexToRgba(props.color || StyleColor.Blue600, 15)};
		color: ${(props: DriveItemDownloadButtonProps) => props.color || StyleColor.Blue600};
	}
`;

export { StyledDownloadGroupButton };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DownloadGroupButton/styles.ts